"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPauseTrackingRequestT = exports.SetPauseTrackingRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SetPauseTrackingRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSetPauseTrackingRequest(bb, obj) {
        return (obj || new SetPauseTrackingRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSetPauseTrackingRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SetPauseTrackingRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Pauses skeleton tracking if true, resumes skeleton tracking if false.
     */
    pauseTracking() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startSetPauseTrackingRequest(builder) {
        builder.startObject(1);
    }
    static addPauseTracking(builder, pauseTracking) {
        builder.addFieldInt8(0, +pauseTracking, +false);
    }
    static endSetPauseTrackingRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSetPauseTrackingRequest(builder, pauseTracking) {
        SetPauseTrackingRequest.startSetPauseTrackingRequest(builder);
        SetPauseTrackingRequest.addPauseTracking(builder, pauseTracking);
        return SetPauseTrackingRequest.endSetPauseTrackingRequest(builder);
    }
    unpack() {
        return new SetPauseTrackingRequestT(this.pauseTracking());
    }
    unpackTo(_o) {
        _o.pauseTracking = this.pauseTracking();
    }
}
exports.SetPauseTrackingRequest = SetPauseTrackingRequest;
class SetPauseTrackingRequestT {
    constructor(pauseTracking = false) {
        this.pauseTracking = pauseTracking;
    }
    pack(builder) {
        return SetPauseTrackingRequest.createSetPauseTrackingRequest(builder, this.pauseTracking);
    }
}
exports.SetPauseTrackingRequestT = SetPauseTrackingRequestT;
